var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login"},[_c('h2',[_vm._v("Log in")]),_c('v-btn',{staticClass:"login-google-btn",attrs:{"depressed":"","color":"primary"},on:{"click":_vm.userClickOnLogIn}},[_vm._v(_vm._s(_vm.$t("login.continue_with_google")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }